import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AnnualPlanService } from '../../providers/annual-plans.services';
import { Subscription } from 'rxjs';
import {
  MAT_DIALOG_DATA,
  MatDialogActions, MatDialogClose,
  MatDialogContent, MatDialogModule,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AnnualPlan } from "../../../common/models/annual-plan";
import { UtilsProvider } from "../../../common/providers/utils-provider.service";
import { TranslateModule } from "@ngx-translate/core";
import { MatError, MatFormField, MatFormFieldModule, MatLabel } from "@angular/material/form-field";
import { MatOption, MatSelect, MatSelectModule } from "@angular/material/select";
import {
  MatDatepicker,
  MatDatepickerInput,
  MatDatepickerModule,
  MatDatepickerToggle
} from "@angular/material/datepicker";
import { MatInput, MatInputModule } from "@angular/material/input";
import { MatButton } from "@angular/material/button";
import { NgForOf, NgIf } from "@angular/common";
import { MatIconModule } from "@angular/material/icon";

@Component({
  selector: 'annual-plan-dialog-form-athlete-plan-import',
  templateUrl: './annual-plan-dialog-form-athlete-plan-import.component.html',
  styleUrls: ['./annual-plan-dialog-form-athlete-plan-import.scss'],
  imports: [
    TranslateModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
    MatDialogModule,
    ReactiveFormsModule,
    MatButton,
    MatError,
    MatLabel,
    NgForOf,
    NgIf
  ],
  standalone: true
})
export class AnnualPlanDialogFormAthletePlanImportComponent implements OnInit {

    public importPlanForm: FormGroup;
    public isSubmitting = false;
    public annualPlans: AnnualPlan[] = [];
    public annualPlan: AnnualPlan = {} as AnnualPlan;
    public startDate: Date = new Date();

    constructor(
        public dialog: MatDialogRef<AnnualPlanDialogFormAthletePlanImportComponent>,
        private utils: UtilsProvider,
        private fb: FormBuilder,
        private annualPlanProvider: AnnualPlanService,
        private toaster: MatSnackBar,
        @Inject(MAT_DIALOG_DATA) public data:any) {
        // use the FormBuilder to create a form group
        this.importPlanForm = this.fb.group({
            plan: new FormControl(null, [Validators.required]),
            startedAt: new FormControl(null, [Validators.required])
        });
    }

    public ngOnInit() {
        // TODO : VH - Load plans for organization
        this.annualPlanProvider.findAllByOrganization(this.data.organization).subscribe((annualPlans) => {
            this.annualPlans = annualPlans;
        });
    }


    public submitForm() {
        this.isSubmitting = true;

        if (this.importPlanForm.valid) {
            Object.assign(this.annualPlan, this.data.annualPlanRow);

            this.annualPlanProvider.assignPlanToAthlete(
              this.data.organization,
              this.importPlanForm.get('plan')?.value,
              this.data.athlete,
              this.importPlanForm.get('startedAt')?.value
            ).subscribe({
              next: (data) => {
                this.dialog.close({annualPlan: data, toDelete: false});
              },
              error: (err) => {
                this.toaster.open(err.message, '', {duration: 5000});
              }
            });
        } else {
            this.utils.validateAllFormFields(this.importPlanForm);
            this.isSubmitting = false;
        }
    }

    get f() {
        return this.importPlanForm.controls;
    }
}
